import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-divider mt-auto">
      <div className="page-width px-5 py-10 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <Link to="/" className="font-display text-4xl tracking-tight text-slate-900">
            Encreage<span className="text-[color:var(--site-accent)]">.</span>
          </Link>

          <ul className="flex flex-wrap gap-5 text-[11px] uppercase tracking-[0.28em] text-slate-500">
            <li>
              <Link to="/privacy" className="transition-colors hover:text-slate-900">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="transition-colors hover:text-slate-900">
                Terms
              </Link>
            </li>
            <li>
              <Link to="/contact" className="transition-colors hover:text-slate-900">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/store" className="transition-colors hover:text-slate-900">
                Store
              </Link>
            </li>
            <li>
              <Link to="/blog" className="transition-colors hover:text-slate-900">
                Journal
              </Link>
            </li>
          </ul>
        </div>

        <div className="mt-6 flex flex-col gap-2 text-[11px] uppercase tracking-[0.22em] text-slate-500 md:flex-row md:items-center md:justify-between">
          <span>{currentYear} Encreage</span>
          <span>All rights reserved</span>
        </div>
      </div>
    </footer>
  );
}
